import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import report from '../views/report.vue'
import { getUserInfo } from '@/api/user'
import { SearchUrlParams } from '@/utils'
import onlineRegistration from '../views/onlineRegistration.vue' // 在线预约
import onlineRegistrationV2 from '../views/onlineRegistrationV2.vue' // 在线预约-新
import myRegistration from '../views/myRegistration.vue' //我的预约
import doctorDetail from '../views/doctorDetail.vue' // 医生详情
import doctorDetailV2 from "../views/doctorDetailV2.vue"; //医生详情-新
import confirmation from '../views/confirmation.vue' //预约确认
import successful from '../views/successful.vue' //预约成功
import drugQuery from '../views/drugQuery.vue' //药品查询
import drugDetail from '../views/drugDetail.vue' //药品详情
import medicalBooking from '../views/medicalBooking.vue' //体检预约
import medicalReport from '../views/medicalReport.vue' //体检预约
import articleList from '../views/articleList.vue' //文章列表
import articleDetail from '../views/articleDetail.vue' //文章详情
import curve from '../views/curve.vue' //曲线
import chat from '../views/chat.vue' //检后咨询
import psychologicalCounseling from "@/views/psychologicalCounseling.vue"; //心理咨询
import registrationInfo from '../views/registration-info.vue' //预约须知
import DDList from '../views/DDList.vue' //医生、科室列表
import improveInfo from '../views/improveInfo.vue' //完善信息
import confirmationV2 from '../views/confirmationV2.vue' //预约确认-新
import doctorList from "../views/doctorList.vue";
import login from '../views/login.vue'
import healthTable from '../views/healthTable.vue'
import { message } from 'ant-design-vue'
import LayoutMenus from '@/components/Layout/LayoutMenus'
import headerSearch from '@/components/Layout/LayoutMenusSearch'

// 申请休假相关页面
import sickLeaveList from '../views/sick-leave-application/index.vue'
import sickLeaveAdd from '../views/sick-leave-application/add-application.vue'
import sickLeaveSuccess from '../views/sick-leave-application/apply-success.vue'
import sickLeaveDetail from '../views/sick-leave-application/detail.vue'

import { uuid } from '@/utils'
import store from '@/store'
import versionUpdate from '@/update/versionUpdate.js';

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'layout',
    component: LayoutMenus,
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: 'index',
        component: index
      },
      {
        path: '/report',
        name: 'report',
        component: report
      },
      {
        path: '/login',
        name: 'login',
        component: login
      },
      {
        path: '/registrationInfo',
        name: 'registrationInfo',
        component: registrationInfo
      },
      {
        path: '/onlineRegistration',
        name: 'onlineRegistration',
        component: onlineRegistration
      },
      //预约挂号-新
      {
        path: "/onlineRegistrationV2",
        name: "onlineRegistrationV2",
        component: onlineRegistrationV2
      },
      {
        path: '/myRegistration',
        name: 'myRegistration',
        component: myRegistration
      },
      {
        path: "/DDList",
        name: "DDList",
        component: DDList
      },
      {
        path: '/doctorList',
        name: 'doctorList',
        component: doctorList
      },
      {
        path: '/doctorDetail',
        name: 'doctorDetail',
        component: doctorDetail
      },
      {
        path: "/doctorDetailV2",
        name: "doctorDetailV2",
        component: doctorDetailV2
      },
      {
        path: '/confirmation',
        name: 'confirmation',
        component: confirmation
      },
      {
        path: "/confirmationV2",
        name: "confirmationV2",
        component: confirmationV2
      },
      {
        path: '/successful',
        name: 'successful',
        component: successful
      },
      {
        path: '/drugQuery',
        name: 'drugQuery',
        component: drugQuery
      },
      {
        path: '/drugDetail',
        name: 'drugDetail',
        component: drugDetail
      },
      {
        path: '/medicalBooking', //体检预约
        name: 'medicalBooking',
        component: medicalBooking
      },
      {
        path: '/healthTable', //体检数据对比分析
        name: 'healthTable',
        component: healthTable
      },
      {
        path: '/curve', //项目趋势
        name: 'curve',
        component: curve
      },
      {
        path: '/medicalReport', //体检报告
        name: 'medicalReport',
        component: medicalReport
      },
      {
        path: '/articleDetail', //文章详情
        name: 'articleDetail',
        component: articleDetail
      },
      {
        path: '/chat', //检后资讯
        name: 'chat',
        component: chat
      },
      {
        path: "/psychologicalCounseling",//心理咨询
        name: 'psychologicalCounseling',
        component: psychologicalCounseling
      },
      {
        path: '/improveInfo',//完善信息
        name: 'improveInfo',
        component: improveInfo
      },
      {
        path: '/sick-leave-list', // 申请休假列表
        name: 'sickLeaveList',
        component: sickLeaveList
      },
      {
        path: '/sick-leave-add', // 申请添加/编辑
        name: 'sickLeaveAdd',
        component: sickLeaveAdd
      },
      {
        path: '/sick-leave-success', // 申请成功
        name: 'sickLeaveSuccess',
        component: sickLeaveSuccess
      },
      {
        path: '/sick-leave-detail', // 申请详情
        name: 'sickLeaveDetail',
        component: sickLeaveDetail
      }
    ]
  },
  {
    path: '/',
    name: 'headerSearch',
    component: headerSearch,
    children: [
      {
        path: '/articleList',
        name: 'articleList',
        component: articleList
      }
    ]
  }
]

const router = new VueRouter({
  routes
})
const routesWhiteList = ['/', '/index', '/articleList', '/articleDetail', '/improveInfo']
//导航守卫，非登录状态先登录
router.beforeEach(async (to, from, next) => {
  /** 判断当前代码版本是否与服务器中代码版本一致，如不一致则刷新页面获取最新*/
  versionUpdate.isNewVersion();

  /* 路由发生变化修改页面title */
  let url = window.location.href;
  let signOn = SearchUrlParams(url, 'signOn')
  let urlId = SearchUrlParams(url, 'id')
  let redirect = SearchUrlParams(url, 'redirect')

  if (signOn && signOn === 'true') {
    var oBtn = document.createElement('input')
    oBtn.id = 'btn'
    oBtn.type = 'button'
    oBtn.value = '按钮'
    oBtn.onclick = function () {
      let id = uuid()
      let url = "medicalBooking";
      window.open(
        `https://zjuam.zju.edu.cn/cas/oauth2.0/authorize?response_type=code&client_id=U2ZEp4RHRJTgzgy5Pq&redirect_uri=https://xyszyl.zju.edu.cn/medical/auth/codeRedirect&state=${id}_PC_${url}`,
        '_self'
      )
    }
    document.body.appendChild(oBtn)
    document.getElementById('btn').click()
    document.body.removeChild(oBtn)
  }


  if (!sessionStorage.getItem('token') && urlId) {
    const params = {
      id: urlId
    }
    const { code, data, msg } = await getUserInfo(params)
    if (code == 200) {
      sessionStorage.setItem('uuid', urlId)
      if (data.e) {
        store.commit('login/changLogin', true)
        sessionStorage.setItem('userInfo', JSON.stringify(data.e)) //测试
      } else {

      }
      sessionStorage.setItem('token', data.token)
      //跳转到原页面
      if (redirect) {
        next({ path: '/' + redirect, replace: true })
        sessionStorage.removeItem("redirectUrl");
      }
    } else {
      message.error(msg || '登录失败')
    }
    next()
  } else {
    if (
      (sessionStorage.getItem('uuid') || sessionStorage.getItem('userInfo')) &&
      signOn == 'true'
    ) {
      next({ path: '/medicalBooking', replace: true })
    } else if (
      sessionStorage.getItem('uuid') ||
      sessionStorage.getItem('userInfo')
    ) {
      next()
    } else if (routesWhiteList.indexOf(to.path) !== -1) {
      next()
    } else if (to.path == '/login') {
      next()
    } else {
      // 保存当前路径以便登录后跳转
      sessionStorage.setItem('redirectUrl', to.fullPath)
      next({ path: '/login', replace: true })
    }
  }
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
